export function firstFiniteValue(values) {
  return (values ?? []).find((value) => Number.isFinite(value)) ?? null;
}

function datedPointValue(point) {
  const value = point?.value
    ?? point?.close
    ?? point?.growth_multiple
    ?? point?.total_return
    ?? point?.normalized
    ?? point?.raw;
  const numeric = Number(value);
  return Number.isFinite(numeric) ? numeric : null;
}

/** Align sparse dated observations to a shared chart calendar. A leading
 * baseline is applied only before the first real point; internal/later gaps
 * remain null and are never interpolated. */
export function alignDatedValues(points, dates, { leadingValue = null } = {}) {
  const entries = (points ?? [])
    .map((point) => [String(point?.date ?? point?.trade_date ?? point?.t ?? ""), datedPointValue(point)])
    .filter(([date, value]) => date && Number.isFinite(value));
  const byDate = new Map(entries);
  const firstDate = entries.map(([date]) => date).sort()[0] ?? null;
  return (dates ?? []).map((date) => {
    if (byDate.has(date)) return byDate.get(date);
    if (leadingValue !== null && firstDate && date < firstDate) return leadingValue;
    return null;
  });
}

/**
 * Rebase a deterministic value/NAV series to the first observable point in the
 * selected window. Missing observations remain gaps; no interpolation occurs.
 */
export function rebaseComparisonValues(values, { keepAbsolute = false } = {}) {
  if (keepAbsolute) return [...(values ?? [])];
  const base = firstFiniteValue(values);
  if (!Number.isFinite(base)) return (values ?? []).map(() => null);
  if (base === 0) {
    return (values ?? []).map((value) => Number.isFinite(value) ? value : null);
  }
  return (values ?? []).map((value) => Number.isFinite(value) ? value / base - 1 : null);
}
